import React from "react";
import content from "../content";

const KITCHEN_IMG =
    "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/z5sah7dz_b%C3%A9a%20et%20thierry%20salle%20la%20table%20d%27albigny.jpg";

export const Story = () => {
    const { story } = content;
    return (
        <section
            id="histoire"
            data-testid="story-section"
            className="relative bg-[#F9F8F6] py-24 sm:py-36 px-6 sm:px-12 lg:px-24"
        >
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                <div className="lg:col-span-6 reveal">
                    <p className="text-[10px] sm:text-xs uppercase tracking-[0.4em] text-[#8B5A2B] font-bold mb-6">
                        {story.overline}
                    </p>
                    <h2
                        data-testid="story-title"
                        className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#2C1E16] leading-[1.05] mb-8 text-balance"
                    >
                        {story.title}{" "}
                        <span className="italic text-[#8B5A2B]">{story.titleItalic}</span>
                        {story.titleEnd}
                    </h2>
                    <div className="space-y-6 text-[#5C4033] text-base sm:text-lg leading-relaxed max-w-xl">
                        {story.paragraphs.map((p, i) => (
                            <p key={i}>{p}</p>
                        ))}
                    </div>
                </div>

                <div className="lg:col-span-6 reveal relative">
                    <div className="relative">
                        <div className="absolute -top-6 -left-6 w-full h-full border border-[#8B5A2B]/40" />
                        <img
                            src={KITCHEN_IMG}
                            alt="Béa et Thierry en salle"
                            data-testid="story-image"
                            className="relative w-full h-[420px] sm:h-[520px] object-cover shadow-xl"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};
